var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpringFrameworkLogo2018(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg29",
    xmlSpace: "preserve",
    width: 245.09332,
    height: 62.986668,
    viewBox: "0 0 245.09332 62.986668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g37",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,62.986667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g39",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 605.484,143.859 c -5.636,3.043 -9.972,9.559 -9.972,18.243 0,11.707 9.105,21.199 21.289,21.199 4.316,0 8.238,-1.27 11.254,-3.008 22.16,-14.766 45.164,-22.148 65.965,-22.148 22.562,0 35.578,9.558 35.578,24.765 v 0.86 c 0,17.793 -24.285,23.859 -51.211,32.097 -33.828,9.555 -71.582,23.426 -71.582,67.262 v 0.879 c 0,43.402 36.015,69.863 81.582,69.863 24.308,0 49.898,-6.953 72.031,-18.652 7.398,-3.918 12.578,-10.864 12.578,-19.953 0,-12.164 -9.531,-21.297 -21.68,-21.297 -4.363,0 -6.964,0.871 -10.398,2.617 -18.691,9.559 -37.777,15.644 -53.828,15.644 -20.41,0 -32.129,-9.57 -32.129,-22.597 v -0.844 c 0,-16.93 24.734,-23.855 51.648,-32.551 33.414,-10.422 71.168,-25.601 71.168,-66.824 v -0.879 c 0,-48.164 -37.339,-72.004 -85.062,-72.004 -29.055,0 -60.735,9.082 -87.231,27.328",
    style: {
      fill: "#5fb832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 981.195,234.973 v 0.879 c 0,44.242 -29.949,73.32 -65.515,73.32 -35.582,0 -66.825,-29.508 -66.825,-73.32 v -0.879 c 0,-43.828 31.243,-73.364 66.825,-73.364 36.015,0 65.515,28.227 65.515,73.364 m -183.558,92.445 c 0,14.727 11.269,26.461 26.054,26.461 14.743,0 26.461,-11.734 26.461,-26.461 v -15.645 c 16.926,23.856 40.786,42.957 78.114,42.957 53.8,0 106.314,-42.507 106.314,-118.878 v -0.879 c 0,-75.95 -52.076,-118.899 -106.314,-118.899 -38.184,0 -62.055,19.114 -78.114,40.332 V 75.3047 c 0,-14.8086 -11.718,-26.0938 -26.461,-26.0938 -14.312,0 -26.054,11.2852 -26.054,26.0938 V 327.418",
    style: {
      fill: "#5fb832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1054.47,327.387 c 0,14.726 11.25,26.461 26.01,26.461 14.79,0 26.49,-11.735 26.49,-26.461 v -12.625 c 2.62,19.664 34.7,39.086 57.71,39.086 16.48,0 26.04,-10.84 26.04,-26.02 0,-13.875 -9.12,-23.004 -20.84,-25.168 -37.32,-6.512 -62.91,-39.168 -62.91,-84.347 v -75.704 c 0,-14.336 -11.7,-26.046 -26.49,-26.046 -14.31,0 -26.01,11.289 -26.01,26.046 v 184.778",
    style: {
      fill: "#5fb832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1210.58,327.281 c 0,14.75 11.32,26.485 26.05,26.485 14.75,0 26.47,-11.735 26.47,-26.485 V 142.566 c 0,-14.734 -11.72,-26.003 -26.47,-26.003 -14.33,0 -26.05,11.269 -26.05,26.003 v 184.715",
    style: {
      fill: "#5fb832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1289.57,327.18 c 0,14.75 11.29,26.457 26.02,26.457 14.77,0 26.48,-11.707 26.48,-26.457 v -10.774 c 14.78,21.27 36.01,37.364 71.59,37.364 51.64,0 81.6,-34.731 81.6,-87.665 V 142.598 c 0,-14.746 -11.3,-26.043 -26.05,-26.043 -14.75,0 -26.46,11.297 -26.46,26.043 v 107.445 c 0,35.566 -17.79,55.977 -49.04,55.977 -30.37,0 -51.64,-21.262 -51.64,-56.872 v -106.55 c 0,-14.746 -11.71,-26.043 -26.48,-26.043 -14.31,0 -26.02,11.297 -26.02,26.043 V 327.18",
    style: {
      fill: "#5fb832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1634.05,162.09 c -36.05,0 -65.53,28.215 -65.53,73.351 v 0.852 c 0,44.254 29.92,73.332 65.53,73.332 35.59,0 66.83,-29.516 66.83,-73.332 v -0.852 c 0,-43.839 -31.24,-73.351 -66.83,-73.351 M 1726,354.332 c -14.73,0 -26.45,-11.742 -26.45,-26.473 v -15.617 c -16.94,23.856 -40.78,42.946 -78.08,42.946 -53.84,0 -106.33,-42.508 -106.33,-118.895 v -0.852 c 0,-75.949 52.06,-118.886 106.33,-118.886 37.96,0 61.77,18.886 77.84,40 -2.63,-41.262 -27.89,-63.0472 -72.2,-63.0472 -26.45,0 -49.46,6.5312 -70.32,18.2692 -2.6,1.27 -5.59,2.129 -9.51,2.129 -12.15,0 -22.16,-9.992 -22.16,-21.6716 0,-9.9883 5.65,-17.3633 14.79,-20.836 27.73,-13.457 56.35,-20.4023 88.48,-20.4023 41.25,0 73.37,9.9727 94.2,30.8125 19.05,19.1094 29.47,47.7144 29.47,86.3554 v 159.695 c 0,14.731 -11.28,26.473 -26.06,26.473",
    style: {
      fill: "#5fb832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1263.31,416.996 c 0,-14.601 -11.86,-26.473 -26.48,-26.473 -14.63,0 -26.46,11.872 -26.46,26.473 0,14.641 11.83,26.461 26.46,26.461 14.62,0 26.48,-11.82 26.48,-26.461",
    style: {
      fill: "#5fb832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 429.32,132.246 C 371.109,54.6875 246.762,80.8672 167.039,77.1016 c 0,0 -14.113,-0.7852 -28.328,-3.125 0,0 5.375,2.2929 12.23,4.6562 55.993,19.3633 82.454,23.2542 116.477,40.7302 63.926,32.746 127.547,104.075 140.492,178.172 C 383.578,226.27 309.574,164.934 242.191,140.027 196.07,123.008 112.664,106.445 112.652,106.438 c 0.039,-0.059 -3.324,1.746 -3.371,1.785 -56.7224,27.597 -58.3591,150.449 44.66,190.05 45.168,17.375 88.372,7.832 137.2,19.454 52.078,12.382 112.394,51.418 136.91,102.453 27.484,-81.52 60.5,-209.059 1.269,-287.934 z m 1.012,313.195 c -6.93,-16.464 -15.387,-31.3 -25.137,-44.57 -42.914,44.043 -102.812,71.484 -169.019,71.484 C 105.941,472.355 0,366.402 0,236.191 0,167.93 29.1367,106.367 75.5898,63.2148 l 5.1719,-4.582 c -8.6367,7.043 -9.9648,19.7266 -2.9648,28.3711 7.0429,8.6484 19.7383,9.9883 28.3791,2.9844 8.664,-7.0195 9.984,-19.7344 2.969,-28.3945 -6.989,-8.6641 -19.7075,-9.9727 -28.3598,-2.9805 l 3.5195,-3.1172 C 125.395,20.8984 178.363,0 236.176,0 360.66,0 462.879,96.875 471.629,219.148 c 6.48,59.868 -11.203,135.887 -41.297,226.293",
    style: {
      fill: "#5fb832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1813.55,337.793 h -8.25 v -10.922 h 8.25 c 2.67,0 5.59,2.156 5.59,5.332 0,3.434 -2.92,5.59 -5.59,5.59 z m 5.09,-27.039 -8.01,12.187 h -5.33 v -12.187 h -4.31 v 30.851 h 12.56 c 5.21,0 10.04,-3.691 10.04,-9.402 0,-6.851 -6.11,-9.14 -7.88,-9.14 l 8.26,-12.309 z m -7.37,38.34 c -12.7,0 -22.86,-10.156 -22.86,-22.86 0,-12.562 10.16,-22.851 22.86,-22.851 12.56,0 22.85,10.289 22.85,22.851 0,12.704 -10.29,22.86 -22.85,22.86 z m 0,-49.778 c -14.86,0 -26.92,12.067 -26.92,26.918 0,14.993 12.06,26.926 26.92,26.926 14.98,0 26.92,-11.933 26.92,-26.926 0,-14.851 -11.94,-26.918 -26.92,-26.918",
    style: {
      fill: "#5fb832",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path57"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringFrameworkLogo2018);
export default __webpack_public_path__ + "static/media/Spring_Framework_Logo_2018.9d36c7a1f1b3900c484fead846ba5e9d.svg";
export { ForwardRef as ReactComponent };